import { Link } from "wouter";
import { BrandLogo } from "@/components/brand-logo";
import { ThemeToggle } from "@/components/theme-toggle";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="max-w-3xl mx-auto px-6 min-h-[5.25rem] py-2 flex items-center justify-between gap-4">
          <Link href="/" className="inline-flex min-w-0 max-w-full flex-1 items-center">
            <BrandLogo variant="nav" />
          </Link>
          <ThemeToggle />
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mt-2">Last updated: April 6, 2026</p>
        </div>
        <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
          <p>
            This Privacy Policy describes how TeachersHub (&quot;we&quot;, &quot;us&quot;) collects, uses, and
            protects information when you use our service. This page is a placeholder and should be
            replaced with terms that match your jurisdiction, data practices, and legal review.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">Information we collect</h2>
          <p>
            We may collect account information you provide (for example, when you sign in with Google),
            usage data, and information needed to operate scheduling, students, and payments features you
            choose to use.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">How we use information</h2>
          <p>
            We use collected information to provide and improve the service, authenticate users, and
            communicate with you as needed.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">Contact</h2>
          <p>
            For privacy-related questions, contact us using the support channel described in your product
            or deployment documentation.
          </p>
        </div>
        <p>
          <Link href="/" className="text-sm text-primary hover:underline">
            ← Back to home
          </Link>
        </p>
      </main>
    </div>
  );
}
